import {use} from 'react';

import {TVehicleCreateContext} from '../types/TVehicleCreateContext';
import {VehicleCreate} from '../VehicleCreate';

export const useVehicleCreateContext = (): TVehicleCreateContext => use(VehicleCreate);
